export var useFlags = (function () {
    try {
        return require("launchdarkly-react-client-sdk").useFlags;
    }
    catch (error) {
        console.info("LaunchDarkly React SDK not found, using fallback.");
        return function () { return ({}); };
    }
})();
